module.exports = __webpack_public_path__ + "img/ch-apron-res.9b4dc250.jpg";